import apiClient from '../utils/apiClient';

/**
 * Bank Account API services
 * Quản lý tài khoản ngân hàng hệ thống và gán cho chi nhánh
 */
export const bankAccountAPI = {
  /**
   * Lấy danh sách tài khoản ngân hàng hệ thống
   * @param {Object} params
   */
  getBankAccounts: async (params = {}) => {
    return await apiClient.get({
      url: '/bank-accounts',
      params,
    });
  },

  /**
   * Lấy chi tiết tài khoản theo ID
   */
  getBankAccountById: async (id) => {
    return await apiClient.get({
      url: `/bank-accounts/${id}`,
    });
  },

  /**
   * Tạo tài khoản ngân hàng mới
   */
  createBankAccount: async (data) => {
    return await apiClient.post({
      url: '/bank-accounts',
      data,
    });
  },

  /**
   * Cập nhật tài khoản ngân hàng
   */
  updateBankAccount: async (id, data) => {
    return await apiClient.put({
      url: `/bank-accounts/${id}`,
      data,
    });
  },

  /**
   * Xóa tài khoản ngân hàng
   */
  deleteBankAccount: async (id) => {
    return await apiClient.delete({
      url: `/bank-accounts/${id}`,
    });
  },

  /**
   * (#195715) Tải lên ảnh MÃ QR TĨNH của tài khoản ngân hàng (chỉ ADMIN).
   * Trả về { url, key } — đường dẫn ảnh đã lưu, chưa gắn vào tài khoản.
   */
  uploadStaticQr: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return await apiClient.post({
      url: '/bank-accounts/static-qr',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Lấy danh sách tài khoản gán cho chi nhánh
   */
  getBranchBankAccounts: async (branchId) => {
    return await apiClient.get({
      url: `/branches/${branchId}/bank-accounts`,
    });
  },

  /**
   * Gán tài khoản cho chi nhánh
   */
  assignBankAccountToBranch: async (branchId, data) => {
    return await apiClient.post({
      url: `/branches/${branchId}/bank-accounts`,
      data,
    });
  },

  /**
   * Cập nhật thông tin gán tài khoản cho chi nhánh
   */
  updateBranchBankAccount: async (branchId, assignmentId, data) => {
    return await apiClient.put({
      url: `/branches/${branchId}/bank-accounts/${assignmentId}`,
      data,
    });
  },

  /**
   * (#002727) Quy tắc chia tiền theo mức của chi nhánh.
   * Máy chủ trả về mô tả đã dựng sẵn (`description_lines`) bằng chính hàm mà bộ sinh QR dùng —
   * màn hình CHỈ hiển thị lại, không tự diễn giải, để chú thích không bao giờ lệch hành vi thật.
   */
  getQrSplitConfig: async (branchId) => {
    return await apiClient.get({
      url: `/branches/${branchId}/bank-accounts/qr-split-config`,
    });
  },

  /**
   * Bật/tắt chia tiền theo mức và sửa các mốc tiền.
   */
  updateQrSplitConfig: async (branchId, data) => {
    return await apiClient.put({
      url: `/branches/${branchId}/bank-accounts/qr-split-config`,
      data,
    });
  },

  /**
   * Gỡ tài khoản khỏi chi nhánh
   */
  removeBankAccountFromBranch: async (branchId, assignmentId) => {
    return await apiClient.delete({
      url: `/branches/${branchId}/bank-accounts/${assignmentId}`,
    });
  },
};

